import { useTranslation } from 'react-i18next';

import { locationSourceLabelKey } from '@ngsos/portal-core/incidents';
import type { LocationSource } from '@ngsos/portal-core/realtime';

import { locationSourceIcon } from './locationSourceIcon';

export type LocationSourceBadgeProps = {
  source: LocationSource;
};

export function LocationSourceBadge({ source }: LocationSourceBadgeProps) {
  const { t } = useTranslation();

  return (
    <span className="p-1 d-flex flex-row gap-1 align-items-center">
      <img src={locationSourceIcon(source)} alt="" className="mr-2" style={{ height: '28px' }} />
      <span>{t(locationSourceLabelKey(source))}</span>
    </span>
  );
}
